module.exports = __webpack_public_path__ + "static/img/ps_account.dfdd61ac.png";